import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { SearchToneRequest } from '../api/search/searchtone/searchtonerequest';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SearchToneBasedOnCodeRequest } from '../api/search/searchtonebasedoncode/searchtonebasedoncoderequest';
import { SearchToneBasedOnCodeResponse, SearchToneBasedOnCodeResponseDtoImpl } from '../api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { SearchToneBuilder } from '../dto/searchtone/searchtonebuilder';

export class SearchToneBasedOnCodeAPIProcessorImpl extends APIProcessorImpl<SearchToneBasedOnCodeRequest, SearchToneBasedOnCodeResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SearchToneBasedOnCodeAPIProcessorImpl.name);
    execute(request: SearchToneRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

               let response = new SearchToneBasedOnCodeResponseDtoImpl(APIFeatures.SEARCH_TONE, "Search Tone Success");
               let listOfTones = new SearchToneBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll();

               response.setSearchToneDto(listOfTones);
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SearchToneBasedOnCodeResponseDtoImpl(APIFeatures.SEARCH_TONE, "No Search Tone Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SearchToneBasedOnCodeResponseDtoImpl(APIFeatures.SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new SearchToneBasedOnCodeResponseDtoImpl(APIFeatures.SEARCH_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
    
            this.getAPIFailure(new SearchToneBasedOnCodeResponseDtoImpl(APIFeatures.SEARCH_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/searchtonebasedoncodeapiprocessor.tsx